import produce from 'immer';

import { FETCH_PRODUCT_SUBSCRIPTIONS_SUCCEEDED, LOGOUT } from '../../constants/actionTypes';

const initState = {};

export default produce((draft, action) => {
  switch (action.type) {
    case FETCH_PRODUCT_SUBSCRIPTIONS_SUCCEEDED: {
      return action.payload.package.entities.subscribedPackages;
    }

    case LOGOUT: {
      return initState;
    }
  }
}, initState);
